'use client'
import { StorageService, createStorageService } from '@dynamic-labs/utils';
import { isSSR } from '../../../../shared/utils/functions/isSSR/isSSR.js';

/**
 * Registers the storage service for the SDK.
 * When on server side rendering, the storage service is not available, so we need to register a dummy storage service.
 * @param storagePostfix - The postfix for the storage services.
 */
const useRegisterStorageService = ({ storagePostfix, }) => {
    const storageForSSR = {
        clear: () => undefined,
        getItem: () => null,
        key: () => null,
        length: 0,
        removeItem: () => undefined,
        setItem: () => null,
    };
    const localStorage = isSSR() ? storageForSSR : window.localStorage;
    const sessionStorage = isSSR() ? storageForSSR : window.sessionStorage;
    if (!StorageService.getSourceStorage('localStorage')) {
        StorageService.registerSourceStorage('localStorage', createStorageService({
            postfix: storagePostfix,
            storage: localStorage,
        }));
    }
    if (!StorageService.getSourceStorage('sessionStorage')) {
        StorageService.registerSourceStorage('sessionStorage', createStorageService({
            postfix: storagePostfix,
            storage: sessionStorage,
        }));
    }
};

export { useRegisterStorageService };
